<template>
    <div class="list-wrapper wrapper">
        <div class="list-inner">
            <div class="logo">
                <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du7590crdaf15jp2g79j8nfd9.png" alt="">
            </div>
            <div class="list-total">
                已获取的红包总额&nbsp;<b>{{total}}</b>&nbsp;元
            </div>
            <div class="list-content">
                <h3>
                    <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271qfs1ho91oq813581uvl3k.png" alt="">
                </h3>
                <ul v-if="list && list.length && isLoaded">
                    <li class="list-item" v-for="(item, index) in list" :key="index">
                        <div class="time">{{item.send_time}}</div>
                        <div class="main">
                            <div class="item" @click="hbClick(hbItem)" :class="[hbItem.state == 2 && 'opened']" v-for="hbItem in item.hbList" :key="hbItem.id">
                                <img :src="hbItem.state == 2 ? 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm276vv1mug1ko4lr41vqh3i.png' : 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27ufj181q1ti44eq18n13h.png'" alt="">
                                <span>{{hbItem.state == 2 ? '红包已拆' : '快来拆红包'}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="no-hb" v-if="list && !list.length && isLoaded">
                    <button><img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27jeapmdggub3b18mg3g.png" @click="goHome" alt=""></button>                    
                    <p>您还未获得红包<br/>快去参加活动发动态赢得更多红包吧。</p>
                </div>
                <div class="list-notice" v-if="!isLoaded">
                    数据加载中，请稍后...
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            total: 0,
            isLoaded: false,
            list: []
        }
    },
    computed: {
      ...mapState(['aid', 'userinfo', 'isImmerse', 'shareData', 'versionSize'])
    },
    created() {
        this.getList()
    },
    mounted() {
        this.checkTimeAsync().then(()=> {
            this.share()
        })
        this.setPageLoadingAsync(false)
        document.querySelector('.loading-wrap').style.display = 'none'
        COVER.track(this.aid, 'load', '红包记录页面加载')		
    },
    methods: {
        ...mapActions([
            'setResultDataAsync',
            'setHbShowFlagAsync',
            'checkCanGetHb',
            'checkTimeAsync',
            'setPageLoadingAsync'
        ]),
        getList() {
            COVER.$request('/redpackets/list', {
                aid: this.aid,
                uid: this.userinfo.user_id
            }, 'POST', true).then((res) => {
                if(res.errno == 0 && res.data && res.data.list && res.data.list.length) {
                    this.formatList(res.data.list)
                }
                this.isLoaded = true
            }).catch((err) =>{
                this.isLoaded = true
            })
        },
        formatList(list) {
            let realList = [];
            let itemArr = [];
            let oldList = JSON.parse(JSON.stringify(list))
            oldList.forEach((value, index) => {
                if(value.state == 2){
                    this.total += value.amount;
                }                
                let time = (value.time+'').substring(0, 8);
                let send_time = time.substring(0, 4)+'.'+time.substring(4, 6)+'.'+time.substring(6, 8);
                let timeIndex = itemArr.indexOf(send_time)
                if(timeIndex < 0){
                    itemArr.push(send_time);
                    realList.push({
                        send_time: send_time,
                        hbList: [
                            {
                                amount: (value.amount / 100).toFixed(2),
                                id: value._id,
                                state: value.state,
                                bless: value.bless,
                                info: value.info
                            }
                        ]
                    })
                }else{
                    realList[timeIndex]['hbList'].push({
                        amount: (value.amount / 100).toFixed(2),
                        id: value._id,
                        state: value.state,
                        bless: value.bless,
                        info: value.info
                    });
                }               
            });
            this.list = JSON.parse(JSON.stringify(realList));
            this.total = this.total ? (this.total / 100).toFixed(2) : 0;
        },
        hbClick(data) {
            if(data.state == 2) {
                COVER.track(this.aid, 'click', '红包记录页面进入结果页')
                let resultData = JSON.parse(JSON.stringify(data))
                resultData.amount = resultData.amount != 0.00 ? resultData.amount : ''
                this.setResultDataAsync(resultData)
                this.$router.push(`/result`)
            } else {
                COVER.track(this.aid, 'click', '红包记录页面点击拆红包')
                this.setHbShowFlagAsync({type: 2, id: data.id})
            }
        },
        goHome() {
            this.$router.push(`/`);
        },
        share() {
            let _this = this      
            let ShareData = JSON.parse(JSON.stringify(this.shareData))
            ShareData.callback = function(ret) {
                var data = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret; 
                var origin = data.origin || '';
				if(origin != 'None' && !COVER.isEmpty(origin)){
					COVER.track(_this.aid, 'share', '分享链接到'+origin);  
				} else {
					COVER.track(_this.aid, 'share', '分享'); 
				}
                if((data.status == 'success' || data.status == '1') && _this.userinfo.user_id){
                    _this.checkCanGetHb(2).then(()=> {
                        COVER.track(_this.aid, 'load', '红包雨页面加载')	
                        _this.$router.push('/game?type=2')
                    })
                }           
            }
            if (!this.isImmerse) {
                COVER.share(ShareData)
            }
        }
    }
}
</script>

<style lang="less">
    .list-wrapper {
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261jtb13ff1b8m1mrkett2q.jpg) repeat-y center top;
        background-size: 100% auto;
        position: relative;
        min-height: 100vh;
        &::before, &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271i4e1fpi1fia1aitj4b3l.jpg) no-repeat center top;
            background-size: 100% auto;
        }
        &::after {
            top: auto;
            bottom: 0;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm278ekfqj1bmj1em615g63f.jpg) no-repeat center bottom;
            background-size: 100% auto;
        }
    }
    .list-inner {
        padding-top: 3.977456rem;
        position: relative;
        z-index: 1;
    }
    .list-total{
        font-size: .580113rem;
        color: #e6352b;
        line-height: 1.247987rem;
        text-align: center;
        width: 7.504026rem;
        height: 1.392915rem;
        margin: 0 auto .644122rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271dli1qn91k5c1rb3tkv3m.png) no-repeat center top;
        background-size: 100% auto;
        font-family: 'fzcysc_GBK';
        b {
            font-size: .746699rem;
        }
    }
    .list-content {
        text-align: center;
        h3 {
            width: 3.784219rem;
            margin: 0 auto .37037rem;
        }
        ul {
            letter-spacing: -4px;
        }
        .no-hb {
            width: 8.397746rem;
            margin: .885668rem auto 0;
            height: 3.89694rem;
            background-color: #f8d196;
            border-radius: .241546rem;
            box-shadow: .152979rem 0 .161031rem rgba(0,0,0,0.2);
            box-sizing: border-box;
            padding-top: .668277rem;
            button {
                width: 6.884058rem;
                display: block;
                margin: 0 auto .322061rem;
            }
            p {
                font-size: .322061rem;
                color: #e6352b;
                text-align: center;
                font-weight: bold;
                line-height: 1.5;
            }
        }
    }
    .list-item {
        width: 4.412238rem;
        height: 4.025765rem;
        display: inline-block;
        background-color: #f8d196;
        border-radius: .161031rem;
        box-shadow: .152979rem 0 .161031rem rgba(0,0,0,0.2);
        box-sizing: border-box;
        padding-top: .338164rem;
        margin: 0 .193237rem .354267rem;
        .time {
            letter-spacing: 0;
            font-family: 'fzcysc_GBK';
            font-size: .507407rem;
            color: #f8d196;
            text-align: center;
            width: 3.582931rem;
            margin: 0 auto .281804rem;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2718g213fm909ri323d3j.png) no-repeat center center;
            background-size: 100% auto;
        }
        .item {
            display: inline-block;
            margin: 0 .281804rem;
            position: relative;
            height: 2.52818rem;
            cursor: pointer;
            img {
                width: 1.417069rem;
            }
            span {
                font-size: .235668rem;
                color: #f61919;
                letter-spacing: 0;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;
                border: 1px solid;
                border-radius: .386473rem;
                line-height: .386473rem;
                width: 1.465378rem;
                text-align: center;
            }
            &.opened {
                span {
                    color: #434343;
                }
            }
        }
    }
    .list-notice {
        font-size: 0.4rem;
        color: #f8d196;
    }
</style>